import { SearchFormOptions } from '@setvi/shared/components/intelligence/product-match/enums';
import { SearchType } from '@setvi/shared/components/intelligence/search/interfaces';
import { AISearch } from 'pages/products/hooks/use-ai-search-result';
import { Category } from 'Services/Mongo/Types';
import { AIHeader, RegularHeader, SearchHeader } from './content';

export interface HeaderProps {
  selectedCategory: Category;
  searchContent: SearchType;
  showAIInput: boolean;
  searchQuery: string;
  feedback: JSX.Element;
  // viewMode: Views;
  // toggleViewMode: () => void;
  // eslint-disable-next-line react/no-unused-prop-types
  refetchProducts: () => void;
  closeAISearchMode: () => void;
  closeSearchMode: () => void;
  handleSearch: (val: {
    type: SearchType;
    search: AISearch;
    aiType?: SearchFormOptions;
  }) => void;
  onSelectCategory: (categoryId: Category['_id']) => void;
  handleOpenCategoryDrawer?: () => void;
}

export const Header = ({
  selectedCategory,
  searchContent,
  showAIInput,
  searchQuery,
  feedback,
  // viewMode,
  // toggleViewMode,
  closeSearchMode,
  closeAISearchMode,
  handleSearch,
  onSelectCategory,
  handleOpenCategoryDrawer
}: HeaderProps) => {
  if (searchContent === SearchType.AI)
    return (
      <AIHeader
        showAIInput={showAIInput}
        feedback={feedback}
        closeAISearchMode={closeAISearchMode}
      />
    );

  if (searchContent === SearchType.Regular)
    return (
      <SearchHeader
        searchQuery={searchQuery}
        feedback={feedback}
        closeSearchMode={closeSearchMode}
        handleSearch={handleSearch}
      />
    );

  return (
    <RegularHeader
      selectedCategory={selectedCategory}
      onSelectCategory={onSelectCategory}
      handleOpenCategoryDrawer={handleOpenCategoryDrawer}
    />
  );
};
